import {
  buildDashboardAPI,
  buildFeedbackAPI,
  buildIdServiceAPI,
  buildIdServiceAccountsAPI,
  buildIntegrationAPI,
  buildSsoManagementAPI,
  buildTaskDataAPI,
} from './helper';

// Dashboard api
export const dashboardApi = buildDashboardAPI();
export const dashboardActivityTemplateApi = buildDashboardAPI('activity-template-v1');
export const dashboardBillingApi = buildDashboardAPI('subscriptions-v1');
export const dashboardOrganizationApi = buildDashboardAPI('organization-v1');
export const dashboardProcessApi = buildDashboardAPI('process-v1');
export const dashboardRunApi = buildDashboardAPI('runs-v1');
export const dashboardSecretsApi = buildDashboardAPI('secrets-v1');
export const dashboardUserApi = buildDashboardAPI('user-v1');
export const dashboardWorkspaceApi = buildDashboardAPI('workspace-v1');

// Integration api
export const integrationAssetStorageApi = buildIntegrationAPI('asset-storage-v1');
export const integrationAssistantApi = buildIntegrationAPI('assistant-v1');
export const integrationAuditApi = buildIntegrationAPI('audit-v1');
export const integrationEmailApi = buildIntegrationAPI('email-v1');
export const integrationEmailTriggerApi = buildIntegrationAPI('email-trigger-v1');
export const integrationNotificationApi = buildIntegrationAPI('notification-v1');
export const integrationProcessApi = buildIntegrationAPI('process-v1');
export const integrationSearchApi = buildIntegrationAPI('search-v1');
export const integrationSlackApi = buildIntegrationAPI('slack-v1');
export const integrationWebhooksApi = buildIntegrationAPI('webhooks-v1');
export const integrationWorkspaceKeyApi = buildIntegrationAPI('accesskeys-v1');
export const integrationVersionControlApi = buildIntegrationAPI('version-control-service-v1');
export const integrationRuntimeApi = buildIntegrationAPI('runtime-api-v2');

// Id service api
export const idServiceUserApi = buildIdServiceAPI();
export const idServiceAccountsApi = buildIdServiceAccountsAPI();

// SSO service api
export const ssoManagementApi = buildSsoManagementAPI();

// Task data api
export const taskDataApi = buildTaskDataAPI('json-v1');

// Feedback api
export const feedbackApi = buildFeedbackAPI();
